import { Modal } from "react-bootstrap";

const SHOW_MAX = 20;

export const KPI_TYPE_EDIT_NOTE =
  "Answers companies have already entered are not recalculated. A type you add gives them no emission or energy figures, and a type you remove leaves their old figures in totals and dashboards, until each answer is saved again on the company side.";

/**
 * Asks before saving a new KPI type on KPIs that are already saved, since
 * their existing answers keep the figures they were priced with.
 *
 * @param {object} props
 * @param {string[]|null} props.titles saved KPIs whose type is being edited; null hides the dialog
 * @param {() => void} props.onConfirm
 * @param {() => void} props.onCancel
 */
export default function KpiTypeChangeDialog({ titles, onConfirm, onCancel }) {
  if (!titles) return null;

  return (
    <Modal show onHide={onCancel} centered scrollable className="kgb-root kgb-modal">
      <Modal.Header closeButton>
        <Modal.Title as="h5">
          Change the KPI type of {titles.length} saved KPI{titles.length === 1 ? "" : "s"}?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="kgb-import">
        <p className="kgb-import-warning">{KPI_TYPE_EDIT_NOTE}</p>
        <ul className="kgb-import-list">
          {titles.slice(0, SHOW_MAX).map((title) => (
            <li key={title}>{title}</li>
          ))}
        </ul>
        {titles.length > SHOW_MAX ? <p className="kgb-muted">and {titles.length - SHOW_MAX} more</p> : null}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="kgb-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="kgb-btn kgb-btn--primary" onClick={onConfirm}>
          Save anyway
        </button>
      </Modal.Footer>
    </Modal>
  );
}
